import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
    Row,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
  } from "reactstrap";
import { adult, baby, enf } from '../../../slices/filterSlice';
import { multiDest, volClass, volType } from '../../../slices/volSearchBarSlice';
class BasicFilter extends Component {
    constructor(props) {
        super(props);
        this.state= {
          volClass : "Economy",
          dateExacte: "Date exacte",
          traveler: "Passagers",
          nbrTravaler : 1,
          adult: 1,
          enf : 0,
          baby : 0,
          student : 0,
          senior : 0,
          marin : 0
        }
       }
    IncrementItem = async(type) => {
        switch (type) {
          case "adult":
            await this.setState({ adult: this.state.adult + 1, nbrTravaler:this.state.nbrTravaler +1});
            this.props.dispatch(adult(this.state.adult))
            break;
          case "enf":
            await this.setState({ enf: this.state.enf + 1 , nbrTravaler:this.state.nbrTravaler +1});
            this.props.dispatch(enf(this.state.enf))
            break;
          case "baby":
            await this.setState({ baby: this.state.baby + 1 , nbrTravaler:this.state.nbrTravaler +1});
            this.props.dispatch(baby(this.state.baby))
            break;
            case "student":
            this.setState({ student: this.state.student + 1 , nbrTravaler:this.state.nbrTravaler +1});
            break;
            case "senior":
            this.setState({ senior: this.state.senior + 1, nbrTravaler:this.state.nbrTravaler +1 });
            break;
            case "marin":
            this.setState({ marin: this.state.marin + 1 , nbrTravaler:this.state.nbrTravaler +1});
            break;
          default:
            break;
        }
      }
      DecreaseItem = async (type) => {
        switch (type) {
          case "adult":
            if (this.state.adult > 1) {
            await this.setState({ adult: this.state.adult - 1 ,nbrTravaler : this.state.nbrTravaler -1});
            this.props.dispatch(adult(this.state.adult))
            }
            break;
          case "enf":
            if (this.state.enf > 0) {
            await this.setState({ enf: this.state.enf - 1 ,nbrTravaler : this.state.nbrTravaler -1});
            this.props.dispatch(enf(this.state.enf))
            }
            break;
          case "baby":
            if (this.state.baby > 0) {
            await this.setState({ baby: this.state.baby - 1 , nbrTravaler : this.state.nbrTravaler -1});
            this.props.dispatch(baby(this.state.baby))
            }
            break;
            case "student":
            if (this.state.student > 0) {
            this.setState({ other: this.state.student - 1 ,nbrTravaler : this.state.nbrTravaler -1});
            }
            break;
            case "senior":
            if (this.state.senior > 0) {
            this.setState({ other: this.state.senior - 1 , nbrTravaler : this.state.nbrTravaler -1});
            }
            break;
            case "marin":
            if (this.state.marin > 0) {
            this.setState({ other: this.state.marin - 1 , nbrTravaler : this.state.nbrTravaler -1});
            }
            break;
          default:
            break;
        }
        
      }
      volClass(rr){
        this.props.dispatch(volClass(rr))
      }
    render() {
        const volReturn = this.props.vol.volReturn ;
        const multipleCity = this.props.vol.multiDest 
        return (
            <>
             <div className="d-flex">
              
              <div className="mr-5">
                <UncontrolledDropdown className="noborder"  nav inNavbar>
                  <DropdownToggle
                    id="destination"
                    className="Advanced-btn-ser p-0 pl-1  font-weight-bold vol__type__drop"
                  >
                    {(volReturn && multipleCity === -1   && 'Aller-Retour') || (multipleCity === -1  && !volReturn && 'juste Aller' || 'Multiple')}
             
                    <img className="ml-2"
                      src="/imgs/navebar/downArrow.svg"
                      alt="parcouri"
                      style={{width:"18px",marginBottom:"5px"}}
                    />
                  </DropdownToggle>
                  <Row>
                    <DropdownMenu className=" ">
                      <DropdownItem value="First"onMouseDown={(e)=>this.props.dispatch(volType(true,0))}>Aller-Retour</DropdownItem>
                      <DropdownItem onMouseDown={(e)=>this.props.dispatch(volType(false))}>juste Aller</DropdownItem>
                      <DropdownItem onMouseDown={(e)=>this.props.dispatch(multiDest(0))}>Multiple</DropdownItem>
                    </DropdownMenu>
                  </Row>
                </UncontrolledDropdown>
              </div>
              <div className="mr-5">
                <UncontrolledDropdown className="noborder"  nav inNavbar>
                  <DropdownToggle
                    id="destination"
                    className="Advanced-btn-ser p-0   font-weight-bold vol__type__drop"
                  >
                    {this.state.nbrTravaler} {this.state.traveler} 
             
                    <img className="ml-2"
                      src="/imgs/navebar/downArrow.svg"
                      alt="parcourir"
                      style={{width:"18px",marginBottom:"5px"}}
                    />
                  </DropdownToggle>
                  <Row>
                    <DropdownMenu className=" ">

                     <div class="p-3" id="passg">
                        <div className="type__passg typePssg__vol d-flex justify-content-between align-items-center mb-2">
                          <h6 className='mt-2'>Adultes (+11 ans)</h6>
                          <div className="type__incDec d-flex align-items-center">
                            <span className='filter__inc mr-2' onClick={()=>this.DecreaseItem("adult")}><span>-</span></span>
                            <span>{ this.state.adult }</span>
                            <span className='filter__inc ml-2' onClick={()=>this.IncrementItem("adult")}><span>+</span></span>
                          </div>
                        </div>
                        <div className="type__passg typePssg__vol d-flex justify-content-between align-items-center mb-2">
                          <h6 className='mt-2'>Enfants (2- 11 ans)</h6>
                          <div className="type__incDec d-flex align-items-center">
                          <span className='filter__inc mr-2' onClick={()=>this.DecreaseItem("enf")}><span>-</span></span>
                            <span>{ this.state.enf }</span>
                            <span className='filter__inc ml-2' onClick={()=>this.IncrementItem("enf")}><span>+</span></span>
                          </div>
                        </div>
                        <div className="type__passg typePssg__vol d-flex justify-content-between align-items-center mb-2">
                          <h6 className='mt-2'>Bébé  (-2 ans)</h6>
                          <div className="type__incDec d-flex align-items-center">
                          <span className='filter__inc mr-2' onClick={()=>this.DecreaseItem("baby")}>-</span>
                            <span>{ this.state.baby }</span>
                            <span className='filter__inc ml-2' onClick={()=>this.IncrementItem("baby")}>+</span>
                          </div>
                        </div>
                        <div className="type__passg typePssg__vol d-flex justify-content-between align-items-center mb-2">
                          <h6 className='mt-2'>Étudiant</h6>
                          <div className="type__incDec d-flex align-items-center">
                          <span className='filter__inc mr-2' onClick={()=>this.DecreaseItem("student")}>-</span>
                            <span>{ this.state.student }</span>
                            <span className='filter__inc ml-2' onClick={()=>this.IncrementItem("student")}>+</span>
                          </div>
                        </div>
                        <div className="type__passg typePssg__vol d-flex justify-content-between align-items-center mb-2">
                          <h6 className='mt-2'>Senior (65+)</h6>
                          <div className="type__incDec d-flex align-items-center">
                          <span className='filter__inc mr-2' onClick={()=>this.DecreaseItem("senior")}>-</span>
                            <span>{ this.state.senior }</span>
                            <span className='filter__inc ml-2' onClick={()=>this.IncrementItem("senior")}>+</span>
                          </div>
                        </div>
                        <div className="type__passg typePssg__vol d-flex justify-content-between align-items-center ">
                          <h6 className='mt-2'>Marin</h6>
                          <div className="type__incDec d-flex align-items-center">
                          <span className='filter__inc mr-2' onClick={()=>this.DecreaseItem("marin")}>-</span>
                            <span>{ this.state.marin }</span>
                            <span className='filter__inc ml-2' onClick={()=>this.IncrementItem("marin")}>+</span>
                          </div>
                        </div>
                      </div>
                    </DropdownMenu>
                  </Row>
                </UncontrolledDropdown>
              </div>
         
          
              <div>
                <UncontrolledDropdown className="noborder" nav inNavbar>
                  <DropdownToggle
                    id="destination"
                    className="Advanced-btn-ser p-0  font-weight-bold vol__type__drop"
                  >
                    {this.props.vol.volClass  || this.state.volClass}
                    <img className="ml-2"
                      src="/imgs/navebar/downArrow.svg"
                      alt="parcourir"
                      style={{width:"18px",marginBottom:"5px"}}
                      />
                  </DropdownToggle>
                  <Row>
                    <DropdownMenu>
                      <DropdownItem class="active" value="Economy" onClick={(e) =>this.volClass(e.target.value)} >Economy</DropdownItem>
                      <DropdownItem value="Economy Premium" onClick={(e) =>this.volClass(e.target.value)} >Economy Premium</DropdownItem>
                      <DropdownItem value="Business" onClick={(e) =>this.volClass(e.target.value)} >Business</DropdownItem>
                      <DropdownItem value="First class" onClick={(e) =>this.volClass(e.target.value)} >First</DropdownItem>
                    </DropdownMenu>
                  </Row>
                </UncontrolledDropdown>
              </div>
           
      </div>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
      vol: state.volBarFilter
    }
  }
  export default withRouter(connect(mapStateToProps)(BasicFilter));
